import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { selectors } from 'app-webtech-core';
import { MARK_VOD_AD_WATCHED } from './types';

const markVodAdWatchedAction = actionCreator(MARK_VOD_AD_WATCHED);

export const podTrackerMarkVodAdWatchedThunkAction = (payload) => async (dispatch, getState) => {
  const { viewedVodAdPods } = selectors.podTrackerAds.properties(getState());
  const { vodContentId, adPodIndex, val } = payload;
  viewedVodAdPods[vodContentId] = viewedVodAdPods[vodContentId] || {};
  viewedVodAdPods[vodContentId][adPodIndex] = val;
  dispatch(markVodAdWatchedAction(viewedVodAdPods));
};
